"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Date = _interopRequireDefault(require("@airasia/phoenix-components/components/Date"));

var _BaggageAllowance = _interopRequireDefault(require("@airasia/phoenix-components/components/BaggageAllowance"));

var _JourneyDetailSegment = _interopRequireDefault(require("@airasia/phoenix-components/components/JourneyDetailSegment"));

var _NotificationBannerInline = _interopRequireDefault(require("@airasia/phoenix-components/components/NotificationBannerInline"));

var _constant = require("./constant");

var _JourneyDetails = _interopRequireDefault(require("./JourneyDetails.proptypes"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StyledJourneyDetailsContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyDetails__StyledJourneyDetailsContainer",
  componentId: "sc-1ksr77g-0"
})([""]);

var StyledJourneyContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyDetails__StyledJourneyContainer",
  componentId: "sc-1ksr77g-1"
})(["padding-bottom:10px;", " border-bottom:1px solid ", ";"], function (_ref) {
  var isLast = _ref.isLast,
      theme = _ref.theme;
  return isLast && "border-top: 1px solid ".concat(theme.colors.greyMedium, ";padding-top:20px;");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray;
});

var StyledSegmentContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyDetails__StyledSegmentContainer",
  componentId: "sc-1ksr77g-2"
})(["margin-left:60px;padding:", ";list-style:none;display:flex;flex-direction:column;justify-content:space-between;position:relative;"], function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.space.small, " ").concat(theme.space.none, " ").concat(theme.space.small, " ").concat(theme.space.none);
});

var StyledCarrierItemContainer = _styledComponents.default.div.withConfig({
  displayName: "JourneyDetails__StyledCarrierItemContainer",
  componentId: "sc-1ksr77g-3"
})(["position:relative;"]);

var convertUtcToGmt = function convertUtcToGmt(utcDate, useLocalTimezone) {
  var dateObj = new Date(utcDate); // new Date converts utcDate to local timezone
  // if useLocalTimezone is true
  // return and use dateObj which is already using client's browser timezone

  if (useLocalTimezone) {
    return dateObj;
  }

  var gmtDate = new Date(dateObj.getUTCFullYear(), dateObj.getUTCMonth(), dateObj.getUTCDate(), dateObj.getUTCHours(), dateObj.getUTCMinutes(), dateObj.getUTCSeconds(), dateObj.getUTCMilliseconds());
  return gmtDate;
};

function getDayName(dateTimeString, locale) {
  var date = new Date(dateTimeString); // const dayIndex = date.getUTCDay();

  var formatter = new Intl.DateTimeFormat(locale, {
    weekday: 'long'
  });
  return formatter.format(date); // You can use any date here
  // return language[DAYS_OF_THE_WEEK[dayIndex]];
}

var renderFlightLabel = function renderFlightLabel(designator, isDepart, translation, accessible, theme, locale, useLocalTimezone, showMultiCityHeader) {
  var unifiedConfirmationPageProp = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var displayText = showMultiCityHeader ? language.nextFlight : language.return;
  return /*#__PURE__*/_react.default.createElement(_Text.default, {
    tag: "div",
    bold: true,
    color: _constant.COLORS.GREY_DARKER,
    accessible: accessible,
    display: "inlineFlex",
    theme: theme,
    type: "sub"
  }, isDepart ? "".concat(language.depart, " ").concat(unifiedConfirmationPageProp ? "".concat(language.flight, ": ").concat(getDayName(designator.departureTime, locale)) : '', ",") : "".concat(displayText, "  ").concat(unifiedConfirmationPageProp ? "".concat(language.flight, ": ").concat(getDayName(designator.departureTime, locale)) : '', ","), unifiedConfirmationPageProp ? /*#__PURE__*/_react.default.createElement(_Date.default, {
    accessible: false,
    allowLocaleFormat: true,
    locale: locale,
    color: "greyDarker",
    date: convertUtcToGmt(designator.departureTime, useLocalTimezone),
    format: "dd MMM yyyy",
    size: "small",
    theme: theme,
    customProperties: {
      style: {
        marginLeft: 3
      }
    },
    localeConfig: {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }
  }) : /*#__PURE__*/_react.default.createElement(_Date.default, {
    accessible: accessible,
    allowLocaleFormat: true,
    locale: locale,
    color: "neutral",
    date: convertUtcToGmt(designator.departureTime, useLocalTimezone),
    format: "dd MMM, yyyy",
    size: "small",
    theme: theme,
    customProperties: {
      style: {
        marginLeft: 3
      }
    }
  }));
};

var checkIfJourneyHasBusFerry = function checkIfJourneyHasBusFerry(journeys) {
  var hasBusFerry = journeys.find(function (journey) {
    return journey.segments.some(function (segment) {
      return segment.isBusFerry === true;
    });
  });
  return !!hasBusFerry;
};

var JourneyDetailSegmentRenderer = function JourneyDetailSegmentRenderer(_ref4) {
  var accessible = _ref4.accessible,
      designator = _ref4.designator,
      segments = _ref4.segments,
      translation = _ref4.translation,
      theme = _ref4.theme,
      locale = _ref4.locale,
      hourCycle = _ref4.hourCycle,
      isMobile = _ref4.isMobile,
      useLocalTimezone = _ref4.useLocalTimezone,
      unifiedConfirmationPageProp = _ref4.unifiedConfirmationPageProp;
  var segmentsArray = segments.length ? segments : [{
    designator: designator
  }];
  return /*#__PURE__*/_react.default.createElement(StyledSegmentContainer, null, segmentsArray.map(function (segment, segIndex) {
    // check if the segment is a destination
    var isLast = segIndex + 1 === segments.length; // check if the segment is a stopover

    var isStopover = segIndex % 2 === 1 || segIndex > 0;
    var prevIndex = segIndex - 1;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isStopover &&
    /*#__PURE__*/
    // this is how we render the stopover/layover
    _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledCarrierItemContainer, null, /*#__PURE__*/_react.default.createElement(_JourneyDetailSegment.default, {
      segment: _objectSpread(_objectSpread({}, segment), isStopover && {
        designator: {
          departureStation: segmentsArray[prevIndex].designator.arrivalStation,
          departureAirport: segmentsArray[prevIndex].designator.arrivalAirport,
          departureTime: segmentsArray[prevIndex].designator.arrivalTime,
          arrivalTime: segment.designator.departureTime,
          arrivalStation: segment.designator.arrivalStation,
          arrivalAirport: segment.designator.departureAirport,
          arrivalTerminal: segment.designator.arrivalTerminal,
          departureTerminal: segment.designator.departureTerminal
        }
      }),
      isStopover: true,
      isSelfTransfer: segment.isSelfTransfer,
      isProtected: segment.isProtected,
      protectedBy: segment.protectedBy,
      selfTransferAction: segment.selfTransferAction,
      protectedByAction: segment.protectedByAction,
      accessible: accessible,
      translation: translation,
      theme: theme,
      isTechnicalStop: segment.isTechnicalStop,
      technicalStopLabel: segment.technicalStopLabel,
      locale: locale,
      hourCycle: hourCycle,
      isMobile: isMobile,
      useLocalTimezone: useLocalTimezone,
      unifiedConfirmationPageProp: unifiedConfirmationPageProp
    })), isLast &&
    /*#__PURE__*/
    // this is how we render the takeoff from the stopover/layover
    _react.default.createElement(StyledCarrierItemContainer, null, /*#__PURE__*/_react.default.createElement(_JourneyDetailSegment.default, {
      segment: segment,
      accessible: accessible,
      translation: translation,
      theme: theme,
      locale: locale,
      hourCycle: hourCycle,
      isMobile: isMobile,
      useLocalTimezone: useLocalTimezone,
      unifiedConfirmationPageProp: unifiedConfirmationPageProp
    }))), segmentsArray.length === 1 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledCarrierItemContainer, null, /*#__PURE__*/_react.default.createElement(_JourneyDetailSegment.default, {
      segment: segment,
      accessible: accessible,
      translation: translation,
      theme: theme,
      locale: locale,
      hourCycle: hourCycle,
      isMobile: isMobile,
      useLocalTimezone: useLocalTimezone,
      unifiedConfirmationPageProp: unifiedConfirmationPageProp
    })), isLast && /*#__PURE__*/_react.default.createElement(StyledCarrierItemContainer, null, /*#__PURE__*/_react.default.createElement(_JourneyDetailSegment.default, {
      segment: segment,
      isLast: isLast,
      accessible: accessible,
      translation: translation,
      theme: theme,
      locale: locale,
      hourCycle: hourCycle,
      isMobile: isMobile,
      useLocalTimezone: useLocalTimezone,
      unifiedConfirmationPageProp: unifiedConfirmationPageProp
    }))) :
    /*#__PURE__*/
    // render the default view of segment
    _react.default.createElement(StyledCarrierItemContainer, null, /*#__PURE__*/_react.default.createElement(_JourneyDetailSegment.default, {
      segment: segment,
      isLast: isLast,
      accessible: accessible,
      translation: translation,
      theme: theme,
      locale: locale,
      hourCycle: hourCycle,
      isMobile: isMobile,
      useLocalTimezone: useLocalTimezone,
      unifiedConfirmationPageProp: unifiedConfirmationPageProp
    })));
  }));
};

JourneyDetailSegmentRenderer.propTypes = _JourneyDetails.default.PropTypes;

var JourneyDetails = function JourneyDetails(_ref5) {
  var accessible = _ref5.accessible,
      theme = _ref5.theme,
      customProperties = _ref5.customProperties,
      journeys = _ref5.journeys,
      translation = _ref5.translation,
      locale = _ref5.locale,
      showBaggageAllowance = _ref5.showBaggageAllowance,
      baggageDataList = _ref5.baggageDataList,
      isMobile = _ref5.isMobile,
      hasNoCheckedBaggage = _ref5.hasNoCheckedBaggage,
      hasNoCheckedBaggageOnly = _ref5.hasNoCheckedBaggageOnly,
      hourCycle = _ref5.hourCycle,
      useLocalTimezone = _ref5.useLocalTimezone,
      showMultiCityHeader = _ref5.showMultiCityHeader,
      unifiedConfirmationPageProp = _ref5.unifiedConfirmationPageProp;

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var hasBusFerry = checkIfJourneyHasBusFerry(journeys);
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledJourneyDetailsContainer, (0, _extends2.default)({
    tabIndex: !accessible ? '-1' : '0'
  }, customProperties), journeys.map(function (journey, index) {
    var isLast = index !== 0 && index + 1 === journeys.length;
    return /*#__PURE__*/_react.default.createElement(StyledJourneyContainer, {
      isLast: isLast,
      key: Math.random()
    }, renderFlightLabel(journey.designator, index === 0, language, accessible, theme, locale, useLocalTimezone, showMultiCityHeader, unifiedConfirmationPageProp), /*#__PURE__*/_react.default.createElement(JourneyDetailSegmentRenderer, {
      accessible: accessible,
      designator: journey.designator,
      segments: journey.segments,
      translation: translation,
      locale: locale,
      theme: theme,
      hourCycle: hourCycle,
      isMobile: isMobile,
      useLocalTimezone: useLocalTimezone,
      unifiedConfirmationPageProp: unifiedConfirmationPageProp
    }));
  }), hasBusFerry && /*#__PURE__*/_react.default.createElement(_NotificationBannerInline.default, {
    theme: theme,
    message: language.busFerryNotification
  }), showBaggageAllowance && /*#__PURE__*/_react.default.createElement(_BaggageAllowance.default, {
    accessible: false,
    theme: theme,
    hasBorder: false,
    hasBoxShadow: false,
    title: language.title,
    content: language.content,
    dataList: baggageDataList,
    titleFirst: true,
    isMobile: isMobile,
    imgHeight: 20,
    imgWidth: 20,
    hasNoCheckedBaggage: hasNoCheckedBaggage,
    hasNoCheckedBaggageOnly: hasNoCheckedBaggageOnly,
    translation: language
  })));
};

JourneyDetails.propTypes = _JourneyDetails.default.PropTypes;
JourneyDetails.defaultProps = _JourneyDetails.default.DefaultProps;
var _default = JourneyDetails;
exports.default = _default;